export const TAB_LIST = {
  AREA: 1,
  LENGTH_WIDTH: 0,
};
export const tabListLabels = [
  {
    label: 'Длина х ширина',
    id: 'length',
  },
  {
    label: 'Площадь',
    id: 'area',
  },
];
